import { Component } from '@angular/core';

import type { CardData } from '@shared/components';
import { HoverExpandableCardsComponent } from '@shared/components';

interface NumberedCard {
  number: number;
  title: string;
  description: string;
  upcoming?: boolean;
}

@Component({
  selector: 'app-evrn-exports',
  imports: [HoverExpandableCardsComponent],
  templateUrl: './evrn-exports.html',
  styleUrl: './evrn-exports.scss',
})
export class EvrnExports {
  readonly numberedCards: NumberedCard[] = [
    {
      number: 1,
      title: 'PICTURE\n.PNG',
      description: 'Export first & last frames for layout reference.',
    },
    {
      number: 2,
      title: 'VIDEO\n.MP4',
      description: 'A reference pass for video-to-video renders.',
    },
    {
      number: 3,
      title: 'FULL 3D SCENE\n.GLB, .OBJ, .USD',
      description: 'Export the full 3D scene (with each asset separated) to your 3D engine.',
      upcoming: true,
    },
    {
      number: 4,
      title: 'DCC\nBRIDGE',
      description: 'Direct bridges to Unreal, Unity, Blender, and Houdini.',
      upcoming: true,
    },
  ];

  readonly expandableCards: CardData[] = [
    {
      video: 'assets/evrn-exports/vinod-interior-evrn.webm',
      title: 'EVRN Layout\nReference',
      description:
        'Hand your model an exact layout instead of a prompt, and get the shot you composed.',
    },
    {
      video: 'assets/evrn-exports/vinod-interior-gen-render.webm',
      title: 'Render in Your Model,\nWith Your Layout',
      description: 'Take your EVRN reference into your own generative model.',
    },
  ];
}
